export default {
  init() {

  },
  finalize() {
    $('.global-footer .footer-main .link-sections .link-section .link-section-title').on('click', function() {
      $(this).siblings('.link-section-body').stop().slideToggle();
      $(this).toggleClass('open');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/footer.js